import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MedicalFeePaymentService } from '../../../services/medical-fee/medical-fee-payment.service';
import { MedicalFeePaymentEditInfo } from '../../../model/medical-fee/medical-fee-payment-edit-info';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { MedicalFeePaymentWizardService } from '../../../services/medical-fee/medical-fee-payment-wizard.service';
import { MedicalFeePaymentAmountComponent } from '../medical-fee-payment-amount/medical-fee-payment-amount.component';
import { MatTabGroup, MatDialog } from '@angular/material';
import { MedicalFeeReportDialogComponent } from '../../dialogs/medical-fee-report-dialog/medical-fee-report-dialog.component';
import { MedicalFeePaymentAliquotComponent } from '../medical-fee-payment-aliquot/medical-fee-payment-aliquot.component';

@Component({
  selector: 'app-medical-fee-payment',
  templateUrl: './medical-fee-payment.component.html',
  styleUrls: ['./medical-fee-payment.component.css'],
  providers: [ MedicalFeePaymentWizardService ]
})
export class MedicalFeePaymentComponent implements OnInit {

  loadingAction: boolean;
  loading: boolean;
  medicalPreFeeBillId: number;
  physicianId: number;

  // tslint:disable-next-line: no-input-rename
  @ViewChild('medicalFeePaymentAmount', {static: false}) medicalFeePaymentAmount: MedicalFeePaymentAmountComponent;

  constructor( private activatedRoute: ActivatedRoute,
               private dialog: MatDialog,
               private notificationToastService: NotificationToastService,
               private mfpWizardService: MedicalFeePaymentWizardService ) { }

  async ngOnInit() {

    try {

      this.loading = true;

      this.medicalPreFeeBillId =
      +this.activatedRoute.snapshot.paramMap.get('MedicalPreFeeBillId');
       await this.mfpWizardService.init( this.medicalPreFeeBillId );
      this.physicianId = this.mfpWizardService.getMedicalFeeAmount().Physician.Id;

    } catch ( err ) {

      console.log( err );
      this.notificationToastService.error( JSON.stringify( err.error ), 'Honorarios' );
    } finally {

      this.loading = false;
    }
  }

  selectedIndexChange(newIndex: number) {

     if ( newIndex === 0 ) {
       this.medicalFeePaymentAmount.reload();
     } 
  }

  cancel() {

    history.back();
  }

  async viewReport() {

    try {

      if ( this.medicalFeePaymentAmount.isValid() ) {

        this.loadingAction = true;
        const reportViewer = await this.mfpWizardService.createReport();

        const dialog = this.dialog.open(MedicalFeeReportDialogComponent, {
          width: '90%',
          height: '600px',
          data: reportViewer
        });

        dialog.afterClosed().subscribe( async (value) => {
            if ( value ) {
              await this.createMedicalFeeBill();
            }
        });
      }

    } catch (err) {

      this.notificationToastService.error(JSON.stringify(err.error), 'Honorarios');
    } finally {

      this.loadingAction = false;
    }
  }

  private async createMedicalFeeBill() {

    try {

      this.loadingAction = true;

      await this.mfpWizardService.createMedicalFeeBill();
      this.notificationToastService.success('Se liquidaron los honorarios correctamente', 'Honorarios');
      this.cancel();

    } catch ( err ) {

      console.log( err );
      this.notificationToastService.error( JSON.stringify( err.error ), 'Honorarios' );
    } finally {

      this.loadingAction = false;
    }
  }
}
